import styled from "styled-components";

export type SectionTone = "warning" | "info";

type SectionHeaderProps = {
  tone: SectionTone;
  title: string;
  count: number;
  description: string;
};

export function SectionHeader({ tone, title, count, description }: SectionHeaderProps) {
  return (
    <Wrapper $tone={tone}>
      <TopRow>
        <Title>
          {title} <Count>({count})</Count>
        </Title>
      </TopRow>
      <Description>{description}</Description>
    </Wrapper>
  );
}

const Wrapper = styled.div<{ $tone: SectionTone }>`
  background: ${({ theme, $tone }) =>
    $tone === "warning" ? theme.color.warningMuted : theme.color.accentMuted};
  border-left: 3px solid
    ${({ theme, $tone }) =>
      $tone === "warning" ? theme.color.warning : theme.color.accent};
  border-radius: ${({ theme }) => theme.radius.sm};
  padding: ${({ theme }) => `${theme.space.sm} ${theme.space.md}`};
`;

const TopRow = styled.div`
  display: flex;
  align-items: baseline;
  gap: ${({ theme }) => theme.space.sm};
`;

const Title = styled.div`
  font-weight: ${({ theme }) => theme.font.weight.bold};
  font-size: ${({ theme }) => theme.font.size.sm};
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: ${({ theme }) => theme.color.textPrimary};
`;

const Count = styled.span`
  font-weight: ${({ theme }) => theme.font.weight.normal};
  color: ${({ theme }) => theme.color.textMuted};
`;

const Description = styled.div`
  font-size: ${({ theme }) => theme.font.size.sm};
  color: ${({ theme }) => theme.color.textMuted};
  margin-top: 2px;
`;
